export default "__VITE_ASSET__D864WDZL__"